import React from "react";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import NIHClinGenDiseaseValidityContent from "./NIHClinGenDiseaseValidityContent";
import { NIHClinGenDiseaseValidityType } from "../../../../components/componentTypes/NIHClinGenDiseaseValidityType";
import HelperText from "../../../../components/atoms/HelperText";

const NIHClinGenDiseaseValidity = ({ data }) => {
  if (
    !data ||
    Object.keys(data || {}).length === 0 ||
    !data?.items ||
    data?.items?.length === 0
  )
    return null;

  return (
    <div className="varsome-result-fixed">
      <div
        className="varsome-container varsome-container__basic"
        data-testid="nih-clingen-disease-validity-component"
      >
        <ComponentPanel
          title="NIH ClinGen Disease Validity"
          version={data?.version}
          url={getVarsoUrl(
            "https://search.clinicalgenome.org/kb/gene-validity?page=1&size=25&search="
          )}
          helperPopup={
            <HelperText fieldDescriptionKey="NIH ClinGen Disease Validity" />
          }
          content={
            <div className="varsome-inner-container">
              {data?.items && (
                <NIHClinGenDiseaseValidityContent items={data?.items} />
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};

NIHClinGenDiseaseValidity.propTypes = {
  data: NIHClinGenDiseaseValidityType,
};

NIHClinGenDiseaseValidity.defaultProps = {
  data: {},
};

export default withErrorGuard(
  NIHClinGenDiseaseValidity,
  "NIHClinGenDiseaseValidity",
  "NIH ClinGen Disease Validity"
);
